import React from 'react';

export default class Assessing extends React.Component {
  render() {
    return <div className="content">
      <h1 className="title is-3">Assessing Outcome</h1>
      <img src="/assets/images/step+7.jpeg" />
      <p>Assessing outcome can be difficult.  Measure-based guidance is usually more reliable than general subjective impression. make room for both.</p>
      <p>The shared decision making process moves forward when there is agreement that the intervention produced one of the three definitive outcomes: Effective (It worked), Ineffective (it didn't work), or it was intolerable (stopped due to side effect).</p>
    </div>;
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/more/Assessing.js